/* Broszio product page: gallery swap, live variant switching, quantity stepper.
   Add-to-cart uses the theme's native AJAX cart (data-action="add-to-cart"). */
(function () {
  function init(root) {
    if (!root || root.dataset.bzpInit) return;
    root.dataset.bzpInit = '1';

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-bzp-variants]').textContent); } catch (e) {}

    var stage = root.querySelector('[data-stage]');
    var stageImgs = root.querySelectorAll('.bzp-stage-img');
    var thumbs = root.querySelectorAll('.bzp-thumb');

    function showMedia(mid) {
      if (!mid) return;
      var found = false;
      stageImgs.forEach(function (img) {
        var on = img.dataset.mid === String(mid);
        img.classList.toggle('is-active', on);
        if (on) found = true;
      });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mid === String(mid)); });
      return found;
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.mid); });
    });

    /* ---- quantity ---- */
    var qtyInput = root.querySelector('[data-qty-input]');
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        v = Math.max(1, v + parseInt(b.dataset.qty, 10));
        qtyInput.value = v;
      });
    });

    /* ---- variant switching ---- */
    var optInputs = root.querySelectorAll('[data-opt-input]');
    if (!optInputs.length || !variants.length) return;

    var now = root.querySelector('[data-now]');
    var was = root.querySelector('[data-was]');
    var off = root.querySelector('[data-off]');
    var badge = root.querySelector('[data-badge]');
    var idField = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add]');
    var addText = root.querySelector('[data-add-text]');
    var skuEl = root.querySelector('[data-sku]');
    var eanEl = root.querySelector('[data-ean]');

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-opt]').forEach(function (group) {
        var checked = group.querySelector('[data-opt-input]:checked');
        opts.push(checked ? checked.value : null);
        var cur = group.querySelector('[data-opt-current]');
        if (cur && checked) cur.textContent = checked.value;
      });
      return opts;
    }

    function match(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function update() {
      var opts = selectedOptions();
      var v = match(opts);
      // reflect visual active state on swatches
      root.querySelectorAll('.bzp-swatch').forEach(function (s) {
        var input = s.querySelector('[data-opt-input]');
        s.classList.toggle('is-active', input && input.checked);
      });
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addText) addText.textContent = 'Nicht verfügbar';
        return;
      }
      if (idField) idField.value = v.id;
      if (now) now.textContent = v.price;
      if (was) { if (v.on_sale) { was.textContent = v.compare_at; was.hidden = false; } else { was.hidden = true; } }
      if (off) { if (v.on_sale) { off.textContent = '−' + v.pct + '%'; off.hidden = false; } else { off.hidden = true; } }
      if (badge) { if (v.on_sale) { badge.textContent = '−' + v.pct + '%'; badge.hidden = false; } else { badge.hidden = true; } }
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      if (skuEl && v.sku) skuEl.textContent = 'Artikel-Nr.: ' + v.sku;
      if (eanEl && v.barcode) eanEl.textContent = 'EAN: ' + v.barcode;
      if (v.media_id) showMedia(v.media_id);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    optInputs.forEach(function (inp) { inp.addEventListener('change', update); });
  }

  function boot() { document.querySelectorAll('[data-bzp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-bzp]'); if (r) init(r);
  });
})();
